import script from "./SubmissionList.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionList.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionList.vue?vue&type=style&index=0&id=77c0b47f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c0b47f"]])

export default __exports__